import React from "react";

function FileUploadInput(props) {  
  const {t, file} = props;
  const errors = props.validation && props.validation.errors ? props.validation.errors : "";
  const isDirty = props.validation && props.validation.dirty ? props.validation.dirty : false;
  const formClass = errors[props.name] && isDirty[props.name] ? "form-group invalid" : "form-group";
  return (
    <div className={formClass}>
      <input
        id={props.id}
        name={props.name}
        value={props.value}
        type="file"
        accept="application/pdf"   
        placeholder={props.placeholder}
        onChange={props.onChange}
        required={props.required} 
        maxLength={props.maxLength}       
      />
       <div>

       {file.name && <span   className="file-size">{t("FILE_SIZE")} <span style={{paddingTop:"5px"}} className="always-ltr">{(file.size / (1024*1024)).toFixed(2)}&nbsp;MB</span></span>}
       {errors[props.name] && isDirty[props.name] && (<div style={{paddingTop:"2px"}}className="error-message">{t(errors[props.name])}</div>)}
       </div>
    
    </div>
  );
}
export default FileUploadInput;
